module.exports = __webpack_public_path__ + "static/img/home_new8.0575c96e.jpg";